import { useContext, useEffect, useState } from "react"
import { AcquisitionStoreContext } from "./ModernAcquisitionProvider";
import { ACTIONS, TAcquisitionState } from "./types";

export const useField = <K extends keyof TAcquisitionState>(fieldName: K) => {
    const acquisitionStore = useContext(AcquisitionStoreContext);

    const [field, setField] = useState(acquisitionStore.getState()[fieldName]);

    useEffect(() => {
        const checkForUpdates = () => {
            const newState = acquisitionStore.getState()[fieldName];
            setField((prevState) => prevState === newState ? prevState : newState);
        }
        return acquisitionStore.subscribe(checkForUpdates);
    }, [acquisitionStore, fieldName]);

    const updateField = (fieldStateObj) => {
        acquisitionStore.dispatch({ type: ACTIONS.UPDATE_FIELD, payload: { field: fieldName, ...fieldStateObj } });
    }

    return { field, updateField };
}